module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/35.258b0585.png";